'use client';
import { useEffect } from 'react';
import { useCounters } from '@/shared/hooks/useCounters';

const loadClarity = (projectId: string) => {
  if (typeof window !== 'undefined' && (window as any).clarity) {
    return;
  }

  const script = document.createElement('script');
  script.innerHTML = `
  (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${projectId}");
  `;
  script.id = 'microsoft-clarity';
  document.head.appendChild(script);
};

const ClarityInitializer = () => {
  const { counters, countersError } = useCounters();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
    if (!projectId) {
      console.warn('Clarity project ID not set');
      return;
    }

    if (countersError) {
      console.warn('Failed to fetch Clarity permission:', countersError);
      return;
    }

    if (!counters) return;
    if (!counters?.clarity) return;

    const init = () => {
      loadClarity(projectId);
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 60000 });
    } else {
      setTimeout(init, 5000);
    }
  }, [counters, countersError]);

  return null;
};

export { ClarityInitializer };
